import { render, staticRenderFns } from "./UndoStatisManage.vue?vue&type=template&id=f23edb2c&"
import script from "./UndoStatisManage.vue?vue&type=script&lang=js&"
export * from "./UndoStatisManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports